import { Directive, TemplateRef, inject } from '@angular/core';

/**
 * Marks the lazily-rendered panel body of an `app-topbar-popover`:
 *
 *   <ng-template appPopoverPanel>…</ng-template>
 *
 * A template (not plain projection) so the panel's DOM only exists while the
 * popover is open — list-heavy panels don't render hidden.
 */
@Directive({ selector: 'ng-template[appPopoverPanel]' })
export class PopoverPanelDirective {
  readonly template = inject(TemplateRef);
}
